import React, { Fragment } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { topRatedHelpers } from 'site-modules/shared/utils/top-rated/top-rated-helpers';
import { CmsEntities } from 'client/data/models/cms';
import { WinnerCard } from 'site-modules/editorial/components/top-rated/winner-tiles-nav/2026/winner-card';

export function WinnerTilesNavArticle({
  winnerVehicles,
  year = null,
  winnerTitle = null,
  title = null,
  isMobile = false,
}) {
  const headerToShow = () => {
    const winnerTitleParts = winnerTitle.split(' ');
    const firstString = winnerTitleParts[0];
    const restString = winnerTitleParts.slice(1).join(' ');

    return (
      <Fragment>
        <span className="text-orange-60 fw-medium d-block mb-0_5">
          <span className="hidden-md-down size-24">{firstString}</span>
          <span className="hidden-md-up size-20">{firstString}</span>
        </span>
        <span className="fw-bold text-white">
          <span className="hidden-md-down size-48 ">{restString}</span>
          <span className="hidden-md-up size-30">{restString}</span>
        </span>
      </Fragment>
    );
  };
  const iceArray = [];
  const evArray = [];
  const botbArray = [];
  const getWinnerCard = ({ winnerVehicle, index, categoryTitle, isElectricVehicle }) => (
    <WinnerCard
      tileEntry={winnerVehicle}
      index={index}
      isMobile={isMobile}
      style={{ flex: '1 1 33.33%' }}
      isElectric={isElectricVehicle}
      key={categoryTitle}
    />
  );
  winnerVehicles.reduce((acc, winnerVehicle, index) => {
    const categoryTitle = winnerVehicle.metadata('categoryTitle').value();
    const isBotb = categoryTitle === 'Best of the Best';
    const isElectricVehicle = winnerVehicle.metadata('isElectric').value() === 'true';
    const fig = getWinnerCard({ winnerVehicle, index, categoryTitle, isElectricVehicle });

    if (isBotb) {
      botbArray.push(fig);
    } else if (isElectricVehicle) {
      evArray.push(fig);
    } else {
      iceArray.push(fig);
    }
    return acc;
  }, []);

  if (botbArray.length > 0) {
    const isElectricCategory = title.toLowerCase().includes('electric');
    const botbWinner = botbArray[0];
    if (isElectricCategory) {
      evArray.push(botbWinner);
    } else {
      iceArray.push(botbWinner);
    }
  }

  const renderNavContainer = (array, ariaLabel, isEvCategory = false) => {
    return (
      <nav
        className={classnames('mx-auto d-md-flex justify-content-between', {
          'mb-2': !isEvCategory,
        })}
        aria-label={ariaLabel}
        style={{
          columnGap: '2rem',
          maxWidth: '1040px',
        }}
      >
        {array}
      </nav>
    );
  };

  return (
    <article className="winners mb-3_5 pb-md-1">
      <header
        className={`heading-3 mt-3 pt-2 mb-2_5 mb-md-2 text-center ${topRatedHelpers.swapTextColor('text-white', year)}`}
      >
        {headerToShow()}
      </header>
      {renderNavContainer(iceArray, 'other top rated ICE winners')}
      {renderNavContainer(evArray, 'other top rated EV winners', true)}
    </article>
  );
}

WinnerTilesNavArticle.propTypes = {
  winnerVehicles: PropTypes.arrayOf(CmsEntities.Content).isRequired,
  year: PropTypes.string,
  winnerTitle: PropTypes.string,
  title: PropTypes.string,
  isMobile: PropTypes.bool,
};
